import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; 
import { 
  CalendarDaysIcon, 
  UserGroupIcon, 
  EnvelopeIcon,
  PlusCircleIcon,
  ChartBarIcon,
  TicketIcon,
  ShoppingCartIcon, 
  UsersIcon,
  BookOpenIcon,
  ClipboardDocumentListIcon,
  UserPlusIcon,
  LinkIcon,
  ShieldCheckIcon,
  DocumentTextIcon,
  Bars3Icon // Yeni eklendi
} from '@heroicons/react/24/outline';

const DashboardCard = ({ link, icon, title, description }) => (
  <Link to={link} className="dashboard-card-link" style={{ textDecoration: 'none' }}>
    <div className="dashboard-card border rounded p-3 mb-3 shadow-sm h-100 d-flex flex-column">
      <div className="dashboard-card-content flex-grow-1">
        <div className="dashboard-card-icon mb-2 text-primary" style={{ width: '32px' }}>{icon}</div>
        <h5 className="text-dark fw-bold">{title}</h5>
        <p className="text-muted small">{description}</p>
      </div>
      <div className="card-footer-action text-primary fw-bold small mt-3">
        Go to page &rarr;
      </div>
    </div>
  </Link>
);

const AdminDashboard = () => {
  const { userData } = useAuth();

  // allowedRoles yerine requiredModule kullanıyoruz
  const allCards = [
    {
      title: "Manage Messages",
      description: "View and reply to contact form messages.",
      link: "/admin/manage-messages",
      icon: <TicketIcon />,
      requiredModule: "manage-messages"
    },
    {
      title: "Manage Subscribers",
      description: "View and export book launch email subscribers.",
      link: "/admin/manage-subscribers",
      icon: <UserPlusIcon />,
      requiredModule: "manage-subscribers"
    },
    {
      title: "User Management",
      description: "View, edit roles, and manage all system users.",
      link: "/admin/manage-users",
      icon: <UsersIcon />,
      requiredModule: "manage-users" // Genelde sadece admin
    },
    {
      title: "Role Permissions",
      description: "Yepyeni Modül: Define which roles can access which pages.",
      link: "/admin/role-permissions",
      icon: <ShieldCheckIcon />,
      requiredModule: "manage-users" // Bunu sadece adminlere veya user managerlara gösterelim
    },
   {
      title: "Manage Landing Pages",
      description: "View, edit, and delete custom SEO landing pages.",
      link: "/admin/manage-landing-pages",
      icon: <DocumentTextIcon />, 
      requiredModule: "manage-landing-pages" // <-- BURAYI GÜNCELLEYİN
    },
    {
      title: "Create Landing Page",
      description: "Design custom, SEO-friendly landing pages.",
      link: "/admin/create-landing-page",
      icon: <PlusCircleIcon />, 
      requiredModule: "manage-landing-pages" // <-- BURAYI GÜNCELLEYİN
    },
    {
      title: "Task Board",
      description: "Manage team tasks, view progress and update statuses.",
      link: "/admin/manage-tasks",
      icon: <ClipboardDocumentListIcon />,
      requiredModule: "manage-tasks"
    },
    {
  title: "Manage Menu",
  description: "Customize the top navigation menu using drag and drop.",
  link: "/admin/manage-menu",
  icon: <Bars3Icon />, // @heroicons/react/24/outline import edildiğinden emin olun
  requiredModule: "manage-landing-pages" // Mevcut sayfa yönetim iznine bağladık
},
    {
title: "Manage Affiliates",
description: "Create personalized links for partners and track clicks.",
link: "/admin/manage-affiliates",
icon: <LinkIcon />,
requiredModule: "manage-affiliates"
},
    {
      title: "Manage Book Pages",
      description: "Create landing pages and generate QR codes for your physical books.",
      link: "/admin/manage-book-pages",
      icon: <BookOpenIcon />,
      requiredModule: "manage-book-pages"
    },
    {
      title: "Sales Statistics",
      description: "View sales reports and performance metrics.",
      link: "/admin/statistics",
      icon: <ChartBarIcon />,
      requiredModule: "statistics"
    },
    {
      title: "Manage Orders",
      description: "View and manage all customer orders.",
      link: "/admin/manage-orders",
      icon: <ShoppingCartIcon />,
      requiredModule: "manage-orders"
    },
    {
      title: "Manage Events",
      description: "View, update, and manage all existing events.",
      link: "/admin/manage-events",
      icon: <CalendarDaysIcon />,
      requiredModule: "manage-events"
    },
    {
      title: "Add New Event",
      description: "Quickly create and publish a new community event.",
      link: "/admin/add-event",
      icon: <PlusCircleIcon />,
      requiredModule: "manage-events" // manage-events yetkisi olan ekleyebilsin
    },
    {
      title: "Manage Professionals",
      description: "Approve and manage listings in the professional directory.",
      link: "/admin/manage-professionals",
      icon: <UserGroupIcon />,
      requiredModule: "manage-professionals"
    },
    {
      title: "Email Campaigns",
      description: "Send newsletters and updates to your subscribers.",
      link: "/admin/manage-campaigns",
      icon: <EnvelopeIcon />,
      requiredModule: "manage-campaigns"
    },
  ];

  // Kartları dinamik yetkilere göre filtrele
  const visibleCards = allCards.filter(card => {
    if (!userData) return false;
    if (userData.role === 'admin') return true; // Admin her şeyi görür
    
    // Sabit menüler (dashboard gibi) için kontrol
    if (!card.requiredModule) return true;

    // Kullanıcının özel yetkilerinde bu modül onaylı mı kontrol et
    return userData.permissions && userData.permissions[card.requiredModule];
  });

  return (
    <>
      <div className="mb-4">
        <h1 className="fw-bold">Dashboard</h1>
        <p className="text-muted">Welcome back, {userData?.displayName || userData?.email}! Here's an overview of your site.</p>
      </div>

      <div className="row g-4">
        {visibleCards.map((card, index) => (
          <div className="col-lg-3 col-md-6" key={index}> 
            <DashboardCard {...card} />
          </div>
        ))}
      </div>
    </>
  );
};

export default AdminDashboard;